import React, { Component } from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';

const Layout = ({children}) => {
    return (
        <div style={{ marginRight: 2 + 'em', marginLeft: 2 + 'em' }} >
        <NavMenu />
        <div>
          {children}
        </div>
      </div>
    );
}
export default Layout;
